
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

function Projects() {
  const projects = [
    {
      title: "Phishing Website Detection Research",
      description:
        "Research on developing a phishing website detection model using classification algorithms. Read the published paper for the methodology and findings.",
      externalLink:
        "https://www.mecs-press.org/ijwmt/ijwmt-v14-n5/IJWMT-V14-N5-3.pdf",
      externalLabel: "Read Research Paper",
    },
    {
      title: "Rattle",
      description:
        "GUI-driven Google OAuth phishing toolkit for security research. Create campaigns, capture tokens, and track victims.",
      ghLink: "https://github.com/wilecurity/rattle",
    },
    {
      title: "ClickFix Security Awareness PoC",
      description:
        "A proof of concept demonstrating how deceptive verification pages can manipulate users into performing actions that may compromise their systems. Developed for authorized security testing and awareness.",
      ghLink: "https://github.com/wilecurity/clickfix",
      demoLink: "https://youtu.be/0BeUMTpWc3s",
    },
    {
      title: "WireGuard VPS",
      description:
        "A project focused on deploying WireGuard on a VPS. Visit the repository for the setup process, configuration details, and implementation.",
      ghLink: "https://github.com/wilecurity/wireguard-vps",
    },
    {
      title: "Mask-url",
      description:
        "A URL-related utility developed under Wilecurity. Visit the repository to explore its implementation and intended use.",
      ghLink: "https://github.com/wilecurity/Mask-url",
    },
    {
      title: "Chaindropper",
      description:
        "A tool designed to recover payloads embedded within blockchain transaction data. It demonstrates how arbitrary content can be stored on-chain and later reconstructed directly from transaction hexadecimal payloads.",
      ghLink: "https://github.com/wilecurity/Chaindropper",
    },
    {
      title: "Evil-Dns",
      description:
        "A DNS redirection script that maps specified domain names to a custom IP address, demonstrating how DNS manipulation can redirect users without their knowledge.",
      ghLink: "https://github.com/wilecurity/Evil-Dns",
    },
    {
      title: "HTMLSmuggler",
      description:
        "A project exploring HTML smuggling techniques. Review the repository for implementation details and its intended security research use.",
      ghLink: "https://github.com/wilecurity/htmlsmuggler",
    },
  ];

  return (
    <Container fluid className="project-section">
      <Particle />

      <Container>
        <h1 className="project-heading">
          Security <strong className="purple">Projects</strong>
        </h1>

        <p style={{ color: "white" }}>
          Security tools, technical experiments, and practical projects
          developed through cybersecurity research and engineering.
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((project) => (
            <Col
              md={4}
              sm={6}
              xs={12}
              className="project-card"
              key={project.ghLink}
            >
              <ProjectCard
                title={project.title}
                description={project.description}
                ghLink={project.ghLink}
                demoLink={project.demoLink}
                externalLink={project.externalLink}
                externalLabel={project.externalLabel}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
